import { Form, Select, Tooltip, Radio, Row } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import React from "react";
import PropTypes from "prop-types";
import classes from "../../ReportList/styles.module.css";

export const softLiveOptions = [
  { label: "Default", value: "default" },
  {
    label: "Show in Compliance - Include in Compliance Summary Calculation",
    value: "with_summary",
  },
  {
    label: "Show in Compliance - Exclude in Compliance Summary Calculation",
    value: "without_summary",
  },
];

export const ComplianceConfigFilter = (allindexes, config) => {
  const configObj = config;
  if (Array.isArray(config.searchable_indexes)) {
    configObj.searchable_indexes = config.searchable_indexes.filter((el) =>
      allindexes.includes(el),
    );
  }
  if (Array.isArray(config.alternate_searchable_indexes)) {
    configObj.alternate_searchable_indexes =
      config.alternate_searchable_indexes.filter((el) =>
        allindexes.includes(el),
      );
  }
};

export const getComplianceDefaultConfigs = {
  searchable_indexes: [],
  compliance_level: [],
  compliance_status: [],
  unique_filter_index: [],
  alternate_searchable_indexes: [],
  soft_live_hotel_status: undefined,
};

export const validateCompliance = (data, validate) => {
  const validateObj = validate;
  // validate.qms_submission_method = (!Array.isArray(data.submission_method) || data.submission_method.length===0);//mandatory indexes
  // validate.qms_searchable_indexes = (!Array.isArray(data.searchable_indexes) || data.searchable_indexes.length===0);//mandatory indexes
  // validate.qms_project_indexes_in_session_table = (!Array.isArray(data.project_indexes_in_session_table) || data.project_indexes_in_session_table.length===0)
  validateObj.compliance_unique_filter_index =
    !Array.isArray(data.unique_filter_index) ||
    data.unique_filter_index.length !== 1; // mandatory indexes
};

const tooltipStyle = {
  paddingLeft: 8,
  color: "red",
};

const selectElmStyles = { maxWidth: 450 };

function Compliance(props) {
  const { formItemLayout, config, updateValue, app_id } = props;
  const {
    searchable_indexes,
    compliance_level,
    compliance_status,
    unique_filter_index,
    alternate_searchable_indexes,
    soft_live_hotel_status,
  } = config;
  return (
    <div className="app_config_checkbox_class2">
      <Form.Item {...formItemLayout} label="Searchable Indexes">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="Searchable Indexes"
          value={searchable_indexes}
          onChange={(e) => updateValue(e, app_id, "searchable_indexes")}
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="Compliance Level">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="Compliance Level"
          value={compliance_level}
          onChange={(e) => updateValue(e, app_id, "compliance_level")}
        >
          <Select.Option value="Hotel Level">Hotel Level</Select.Option>
          <Select.Option value="Report Level">Report Level</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="Compliance Status">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch={true}
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="Compliance Status"
          value={compliance_status}
          onChange={(e) => updateValue(e, app_id, "compliance_status")}
        >
          <Select.Option value="Report Status">Report Status</Select.Option>
          <Select.Option value="Signature Status">
            Signature Status
          </Select.Option>
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="Unique Filter Index">
        <Select
          style={selectElmStyles}
          showSearch
          placeholder="Unique Filter Index"
          value={unique_filter_index}
          mode="multiple"
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          className={
            props.validate.compliance_unique_filter_index ? classes.error : ""
          }
          onChange={(e) => updateValue(e, app_id, "unique_filter_index")}
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
        <Tooltip
          placement="topLeft"
          title="please select one unique index"
          arrowPointAtCenter
        >
          <ExclamationCircleOutlined style={tooltipStyle} />
        </Tooltip>
      </Form.Item>
      <Form.Item {...formItemLayout} label="Alternate Searchable Indexes">
        <Select
          style={selectElmStyles}
          mode="multiple"
          showSearch
          filterOption={(input, option) => {
            return (
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
          }}
          placeholder="Alternate Searchable Indexes"
          value={alternate_searchable_indexes}
          onChange={(e) =>
            updateValue(e, app_id, "alternate_searchable_indexes")
          }
        >
          {props.indexes.map((el) => (
            <Select.Option value={el._id} key={el._id}>
              {el.name}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item {...formItemLayout} label="Soft Live - Hotel Status">
        <Radio.Group
          onChange={(e) =>
            updateValue(e.target.value, app_id, "soft_live_hotel_status")
          }
          value={soft_live_hotel_status}
        >
          {softLiveOptions.map((radioItem) => (
            <Row>
              <Radio value={radioItem.value}>{`${radioItem.label}`}</Radio>
            </Row>
          ))}
        </Radio.Group>
      </Form.Item>
    </div>
  );
}

Compliance.propTypes = {
  app_id: PropTypes.string.isRequired,
  config: PropTypes.objectOf({
    searchable_indexes: PropTypes.arrayOf(PropTypes.string),
    compliance_level: PropTypes.arrayOf(PropTypes.string),
    compliance_status: PropTypes.arrayOf(PropTypes.string),
    unique_filter_index: PropTypes.arrayOf(PropTypes.string),
    alternate_searchable_indexes: PropTypes.arrayOf(PropTypes.string),
    soft_live_hotel_status: PropTypes.string,
  }).isRequired,
  updateValue: PropTypes.func,
};

Compliance.defaultProps = {
  updateValue: () => { },
};

export default React.memo(Compliance);